export default __webpack_public_path__ + "static/media/9.77f0cef2.jpg";